import { FormProvider } from 'react-hook-form'

import { Stepper } from '../../../../../../../../components/Stepper'
import { Step } from '../../../../../../../../components/Stepper/Step'
import { BankStepForm } from '../../CommonSteps/BankStepForm'
import { LegalStepForm } from './LegalStepForm'
import { useLegalStepperContainer } from './useLegalStepperContainer'
import { type ExpertDomain } from '../../../../../../../../types/domain/expert-domain'

type LegalPersonStepperProps = {
  expert?: ExpertDomain
}

export const LegalStepperContainer = ({ expert }: LegalPersonStepperProps) => {
  const {
    form,
    currentStep,
    isSubmitting,
    handleCancel,
    handleSubmit,
    setCurrentStep,
  } = useLegalStepperContainer(expert)

  return (
    <FormProvider {...form}>
      <Stepper currentStep={currentStep}>
        <Step index={0}>
          <LegalStepForm
            isSubmitting={isSubmitting}
            onCancel={handleCancel}
            onSubmit={() => setCurrentStep(1)}
          />
        </Step>

        <Step index={1}>
          <BankStepForm
            isSubmitting={isSubmitting}
            onCancel={handleCancel}
            onSubmit={handleSubmit}
          />
        </Step>
      </Stepper>
    </FormProvider>
  )
}
